// extracted by mini-css-extract-plugin
module.exports =  {"tc-enumeration-items":"Items-module__tc-enumeration-items___UAC2z"};